export const getCalcpoly = (state) => state.infographics?.calcPoly;
export const getDisparateBurdenData = (state) => state.infographics?.disparateBurden;
export const getEnforcementOverviewData = (state) => state.infographics?.enforcementOverview;
export const getChosenGeography = (state) => state.infographics?.chosenGeography;
export const getRetailerReductionData = (state) => state.infographics?.retailerReduction;
export const getYouthAppealData = (state) => state.infographics?.youthAppeal;
export const getPosLandscapeData = (state) => state.infographics?.posLandscape;
